module.exports = __webpack_public_path__ + "static/media/ift.d2536167.PNG";